export default {
  kind: {
    ewallet: '數字錢包',
    crypto: '加密貨幣',
    bank: '銀行卡',
    alipay: '支付寶',
  },
  loading: '加載中…',
  feeFree: '免手續費 · 到賬更快',
  feePct: '手續費 {n}%',
  defaultTag: '默認',
  setDefault: '設為默認',
  edit: '編輯賬戶',
  delete: '刪除',
  add: '＋ 添加{name}',
  pickTitle: '選擇提現賬戶',
  formAdd: '添加{name}',
  formEdit: '編輯{name}',
  currency: '幣種',
  currencyType: '貨幣類型',
  network: '主網 / 鏈',
  channel: '錢包渠道',
  holderName: '姓名',
  cardHolder: '持卡人姓名',
  realName: '真實姓名',
  bankName: '開戶銀行',
  region: '開戶地區',
  branch: '開戶網點',
  pickRegion: '選擇開戶地區',
  pickCurrency: '幣種',
  phCurrencySearch: '請輸入搜索關鍵字',
  address: '錢包地址',
  cardNo: '銀行卡號',
  bankAccount: '銀行賬號',
  account: '賬號',
  phHolder: '請輸入姓名(與賬號實名一致)',
  phCardHolder: '請輸入持卡人姓名',
  phRealName: '請輸入真實姓名',
  phBankAccount: '請輸入收款賬號',
  phBranch: '請輸入開戶網點',
  phRegionSelect: '請選擇開戶地區',
  regionCn: '中國',
  regionJp: '日本',
  regionTw: '臺灣',
  regionHk: '香港',
  regionMo: '澳門',
  regionSg: '新加坡',
  phBankSelect: '請選擇開戶銀行',
  phBankSearch: '搜索銀行名稱',
  bankEmpty: '沒有匹配的銀行',
  countryEmpty: '沒有匹配的國家/地區',
  phAlipay: '支付寶賬號(手機號 / 郵箱)',
  phCardNo: '銀行卡號',
  phAddress: 'USDT({ch})錢包地址',
  phEwallet: '{ch} 錢包賬號',
  hintEdit: '· 姓名與開戶信息不可修改,如需變更請刪除後重新添加',
  hintCrypto: '· 請仔細核對地址與主網,轉錯鏈將無法找回',
  hintIdentity: '· 賬戶需與本人實名一致,以確保到賬',
  saveEdit: '保存修改',
  saveUse: '保存並使用',
  toastDefault: '已設為默認提現賬戶',
  toastDeleted: '已刪除該提現賬戶',
  toastSaved: '已保存修改',
  toastSavedUse: '已保存並使用該賬戶',
  errAlipay: '支付寶賬號應為手機號(可帶國際區號)或郵箱,請檢查後重填',
  errBank: '銀行卡號應為 16–19 位數字,請檢查卡號',
  errEwallet: '{ch} 賬號應為 6 位以上字母或數字',
  errCrypto: 'USDT({ch})地址格式不正確,請核對後重填',
  errNameMatch: '提現賬戶姓名需與已有賬戶保持一致({name})',

  fundTitle: '輸入資金密碼',
  fundDesc: {
    generic: '為保障資金安全,請輸入 6 位資金密碼以繼續操作。',
    add: '請輸入資金密碼以添加收款賬戶。',
    deposit: '請輸入資金密碼以確認本次充值。',
    setDefault: '請輸入資金密碼以設置默認提現賬戶。',
    edit: '請輸入資金密碼以編輯收款賬戶。',
    delete: '請輸入資金密碼以刪除該提現賬戶。',
    withdraw: '請輸入資金密碼以確認本次提現。',
    cancelWithdraw: '請輸入資金密碼以撤銷該提現申請。',
    changeLoginPwd: '請輸入資金密碼以修改登錄密碼。',
    changePhone: '請輸入資金密碼以更換綁定手機。',
    changeEmail: '請輸入資金密碼以更換綁定郵箱。',
  },
  fundPh: '6 位資金密碼',
  fundConfirm: '確認',
  fundHint: '連續輸錯 5 次將鎖定 2 小時。',
  errFundFormat: '請輸入 6 位資金密碼',
  errFundFail: '資金密碼錯誤',
  /** 1030 鎖定：按服務端剩餘時間（retry_after_seconds / Retry-After / locked_until） */
  errFundLocked: '資金密碼連續輸錯 5 次，已鎖定，請 {wait}後再試',
  errFundLockedSoon: '資金密碼連續輸錯 5 次，已鎖定，請稍後再試',
}
